import imageInstance from '../../image/instance'

const updateProductImageConfig = (productId, data) => {
  return imageInstance.put('/images/products/' + productId, data)
}

export default updateProductImageConfig
